/* eslint-disable camelcase */
import React from "react"
import { auditShape } from "utils/propTypeShapes"
import TaskLink from "../TaskLink"

const TaskUserCreatedAuditItemDetails = ({ audit }) => {
  const {
    auditedChanges,
    formSubmissionSlug,
    task,
    taskAssignee,
    taskMember,
  } = audit

  const { relationship_type } = auditedChanges

  if (relationship_type === "assignee") {
    return (
      <div>
        Assigned&nbsp;
        <span className="font-semibold">{taskAssignee.fullName}</span> to <TaskLink task={task} formSubmissionSlug={formSubmissionSlug} />.
      </div>
    )
  }

  if (relationship_type === "member") {
    return (
      <div>
        Added&nbsp;
        <span className="font-semibold">{taskMember.fullName}</span> to <TaskLink task={task} formSubmissionSlug={formSubmissionSlug} /> as a member.
      </div>
    )
  }

  return (
    <div>
      Added a user to <TaskLink task={task} formSubmissionSlug={formSubmissionSlug} />.
    </div>
  )
}

TaskUserCreatedAuditItemDetails.propTypes = {
  audit: auditShape.isRequired,
}

export default TaskUserCreatedAuditItemDetails
